module.exports = __webpack_public_path__ + "img/599.725b8ed2.png";